import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconToolbox: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"toolbox"} maskId="square-filled-radius-0-stroke-1-IconToolbox"><path fillRule="evenodd" clipRule="evenodd" d="M6.21649 2H7.78351L10 5.7047V10H12V2H20V10H22V21H2V10H4V5.7047L6.21649 2ZM9 10H5V5.98101L6.78351 3H7.21649L9 5.98101V10ZM13 10H19V3H13V6H16V7H13V10Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconToolbox;
